export const emptyPhone = {
  id: "",
  account_id: -1,
  nickname: null,
  phone_number: "",
  confirmed: false,
  is_primary: false,
  created_at: "",
  updated_at: "",
  deleted_at: null,
}
